import generalMutations from './mutationTypes'

const mutations = {
  [generalMutations.SET_API_VERSION] (state, { response }) {
    state.apiVersion = response.data.version
  },
  [generalMutations.SET_LOADING] (state, loadingState) {
    state.loading = loadingState
  },
  [generalMutations.SET_PERMISSIONS] (state, permissions) {
    state.permissions = permissions
  },
  [generalMutations.SET_FIELD_DEFINITIONS] (state, fields) {
    state.fields = fields
  },
  [generalMutations.SET_ERROR] (state, error) {
    state.error = {
      display: true,
      traceback: error
    }
  },
  [generalMutations.CLEAR_ERROR] (state) {
    state.error = {
      display: false,
      traceback: {}
    }
  },
  [generalMutations.SET_SIDEBAR] (state, navbarState) {
    state.isSidebarToggled = navbarState
  },
  [generalMutations.SET_MOBILE_SIDEBAR] (state, navbarState) {
    state.isMobileSidebarToggled = navbarState
  },
  [generalMutations.SET_ALERT_MESSAGE] (state, alert) {
    const { message, type } = alert
    state.alertMessage = message
    state.alertType = type
  }
}

export default {
  ...mutations
}
